import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { PLACEHOLDER_IMAGE } from '~/config/constants';
import set from 'lodash/set';
import cloneDeep from 'lodash/cloneDeep';
import FileUploaded from '~/components/FileUploaded';
import PreviewAsBackground from '~/components/FileUploaded/picture-preview/PreviewAsBackground';
import { formLabel } from '~/utils/helpers';
import { FormFeedback } from '~/components/FormControl';
import isEmpty from 'lodash/isEmpty';
import { useField } from 'formik';

function AdventureCardBack({ pictureName, pictureVal, categories, categoryId, updateCategories, resetCount }) {
    const dispatch = useDispatch();

    /**
     * @returns {string} tempUrl
     */
    const [tempUrl, setTempUrl] = React.useState(pictureVal);
    const pictureUrl = tempUrl || PLACEHOLDER_IMAGE;

    const inputEl = React.useRef(null);

    //display picture dynamically upon selecting category or get back to original picture when reset.
    React.useEffect(() => {
        setTempUrl(pictureVal);
    }, [resetCount, categoryId]);

    // when uploading new cardBack, update their values in redux so that they can display as preview in next selection.
    React.useEffect(() => {
        let cat = categories.find((item) => item.id == categoryId);
        const cardback = pictureName.split('.').reduce((a, b) => a[b], cat);
        if (cardback === pictureUrl) return;

        cat = cloneDeep(cat);

        set(cat, pictureName, tempUrl);

        dispatch(updateCategories(cat));
    }, [pictureUrl]);

    const [, form] = useField(pictureName);

    return (
        <FileUploaded
            pictureName={pictureName}
            formFileClass={'position-absolute wd-zero z-n1'}
            setTempUrl={setTempUrl}
            inputEl={inputEl}
        >
            <FileUploaded.Preview>
                <PreviewAsBackground
                    pictureUrl={pictureUrl}
                    inputEl={inputEl}
                    id={pictureName}
                />
            </FileUploaded.Preview>
            <figcaption>{formLabel(pictureName)}</figcaption>
            <FormFeedback
                isInvalid={!isEmpty(form.error)}
                errorMessage={form.error}
                className={'text-center'}
            />
        </FileUploaded>
    );
}

AdventureCardBack.propTypes = {
    pictureName: PropTypes.string.isRequired,
    pictureVal: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired, //PropTypes.object is when new picture is uploaded.
    categories: PropTypes.array.isRequired,
    categoryId: PropTypes.number.isRequired,
    updateCategories: PropTypes.func.isRequired,
    resetCount: PropTypes.number.isRequired,
};

export default AdventureCardBack;
